import axios from '@/config/axios'


const urlBase = '/v1/api/mg/users'


export const usersList = (query) => axios.get(`${urlBase}`, {params: query})

export const changeStatus = (uid) => axios.patch(`${urlBase}/${uid}/status`)


export const userProperty = (uid) => axios.get(`${urlBase}/${uid}/property`)

const adminBase = '/v1/api/mg/admin/eazable'


export const adminList = (query) => axios.get(`${adminBase}`, {params: query});


export const updateAdmin = (data) => axios.put(`${adminBase}/${data.id}`, data);

export const createAdmin = (data) => axios.post(`${adminBase}`, data);


export const toProperty = (id) => axios.post(`${adminBase}/session`, id);


const helperAdminBase = '/v1/api/mg/admin/helper'


export const helperAdminList = (query) => axios.get(`${helperAdminBase}`, {params: query});


export const updateHelperAdmin = (data) => axios.put(`${helperAdminBase}/${data.id}`, data);

export const createHelperAdmin = (data) => axios.post(`${helperAdminBase}`, data);
